export default "__VITE_ASSET__BKVIZ5pK__"